import type { Brand } from '../gql';
import type { UserBrand } from '../types/BuyingProfile';

import { randNumber } from '@ngneat/falso';

const MOCK_BRANDS = [
    { brandNumber: '01', brandName: 'VILA', isPrimary: false },
    { brandNumber: '02', brandName: 'ONLY', isPrimary: false },
    { brandNumber: '03', brandName: 'name it', isPrimary: false },
    { brandNumber: '04', brandName: 'Jack & Jones', isPrimary: false },
    { brandNumber: '05', brandName: 'Vero Moda', isPrimary: false },
    { brandNumber: '07', brandName: 'Selected', isPrimary: false },
    { brandNumber: '08', brandName: 'Pieces', isPrimary: false },
    {
        brandNumber: '09',
        brandName: 'Object Collectors Item',
        isPrimary: false,
    },
    { brandNumber: '10', brandName: 'JUNAROSE', isPrimary: false },
    { brandNumber: '11', brandName: 'ONLY & SONS', isPrimary: false },
    { brandNumber: '12', brandName: 'MAMA.LICIOUS', isPrimary: false },
    { brandNumber: '13', brandName: 'Bestseller', isPrimary: false },
    { brandNumber: '14', brandName: 'Y.A.S', isPrimary: false },
    { brandNumber: '18', brandName: 'Noisy May', isPrimary: false },
    { brandNumber: '19', brandName: 'P O S T Y R', isPrimary: false },
];

const mockBrand = (overwrite?: Partial<Brand>): Brand => {
    const mockBrandIndex = randNumber({ min: 0, max: MOCK_BRANDS.length - 1 });
    return {
        ...MOCK_BRANDS[mockBrandIndex],
        ...overwrite,
        ['__typename']: 'Brand',
    };
};

const mockUserBrand = (overwrite?: Partial<UserBrand>): UserBrand => {
    const mockBrandIndex = randNumber({ min: 0, max: MOCK_BRANDS.length - 1 });
    return {
        ...MOCK_BRANDS[mockBrandIndex],
        isPrimary: false,
        ...overwrite,
    };
};

export { mockBrand, mockUserBrand };
